module.exports = __webpack_public_path__ + "img/banner-1.fd49f41f.png";